import { render, staticRenderFns } from "./IbLoader.vue?vue&type=template&id=636f37a8"
import script from "./IbLoader.vue?vue&type=script&lang=js"
export * from "./IbLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports